export const checkboxes = {
  fill: "white",
  stroke: "var(--color--neutral-300)",
  checkedFill: "var(--success-color)",
  checkedStroke: "var(--success-color)",
  focusStroke: "var(--success-color)"
}
